/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import { action, observable } from 'mobx';
import AppSectionBase from './appSectionBase';

export default class ExternalLinkAppSection extends AppSectionBase {
    // To be used for identification of class
    className = 'ExternalLinkAppSection';

    url;

    targetClientID;

    targetScope;

    onSelect;

    type;

    targetType;

    @observable
    onBoardingStatusLight;

    constructor({
        url, targetClientID, targetScope, type, ingestId,
        targetType, onBoardingStatusLight, onSelect = () => {}, ...superProps
    }) {
        super({ ...superProps, sectionHeaderList: null });
        this.url = url;
        this.targetClientID = targetClientID;
        this.targetScope = targetScope;
        this.onSelect = onSelect;
        this.type = type;
        this.ingestId = ingestId;
        this.targetType = targetType;
        this.onBoardingStatusLight = onBoardingStatusLight;
    }

    @action
    setOnBoardingStatusLight(onBoardingStatusLight) {
        this.onBoardingStatusLight = onBoardingStatusLight;
    }
}
